import { motion } from "motion/react";

import { formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";

interface PillSelectProps<T> {
  options: T[];
  value: T;
  onChange: (value: T) => void;
  formatOption?: (option: T) => string;
  className?: string;
}

function PillSelect<T>({
  options,
  value,
  onChange,
  formatOption = (option) => formatToHumanReadable(String(option)),
  className,
}: PillSelectProps<T>) {
  return (
    <div
      className={cx(
        "relative flex w-full flex-row rounded-full border p-px md:p-1",
        className,
      )}
    >
      {options.map((option) => {
        const isSelected = value === option;

        return (
          <div className="relative flex-1" key={String(option)}>
            {isSelected && (
              <motion.div
                className="absolute inset-px rounded-full border border-primary/50 outline-none ring-1 ring-primary/30 md:ring-2"
                layout
                layoutId={`pill-select-${String(options)}`}
                // exit={{ opacity: 0, scale: 0.8 }}
                id={`pill-select-${String(options)}`}
                transition={{
                  type: "spring",
                  ease: "easeInOut",
                  duration: 0.3,
                  bounce: 0.2,
                }}
              />
            )}
            <button
              type="button"
              className="relative w-full rounded-full px-1 py-2 text-body-emphasis text-foreground-secondary transition hover:text-foreground md:px-4"
              onClick={() => onChange(option)}
            >
              {formatOption(option)}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default PillSelect;
